import clsx from 'clsx';

import { ILinkButton } from '../components/buttons/LinkButton';

const sizeMapping = {
  large: 'LinkButton--large',
  medium: 'LinkButton--medium',
  small: 'LinkButton--small',
};

const variantMapping = {
  borderless: 'LinkButton--default',
  danger: 'LinkButton--danger',
  default: 'LinkButton--default',
  important: 'LinkButton--important',
  light: 'LinkButton--light',
  primary: 'LinkButton--default',
  success: 'LinkButton--default',
  secondary: 'LinkButton--secondary',
  selected: 'LinkButton--default',
  unselected: 'LinkButton--unselected',
};

export function classNameForLinkButtonProps(props: ILinkButton) {
  const { className, modifierClassName, size = 'medium', variant, disabled } = props;
  const sizeClassName: string = sizeMapping[size];
  const variantClassName: string = variantMapping[variant] || '';

  return clsx(
    'LinkButton',
    className,
    { disabled },
    modifierClassName,
    sizeClassName,
    variantClassName,
    'link'
  );
}
